import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { getFriendComparison } from '../api';

export default function ComparisonView() {
  const { friendId, systemId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getFriendComparison(friendId, systemId)
      .then(res => setData(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [friendId, systemId]);

  if (loading) return <div className="loading"><div className="spinner spinner--lg" /></div>;
  if (!data) return <div className="empty-state"><p>Could not load comparison.</p></div>;

  const { system, friend, trails, myTotal, friendTotal } = data;
  const total = trails.length;
  const friendName = friend.username || friend.firstName;
  const myPct = total > 0 ? Math.round((myTotal / total) * 100) : 0;
  const friendPct = total > 0 ? Math.round((friendTotal / total) * 100) : 0;

  return (
    <div className="fade-in">
      <Link to={`/friends/${friendId}`} className="back-link">
        <ArrowLeft size={14} /> {friendName}'s Profile
      </Link>

      <div className="page-header" style={{ marginBottom: '24px' }}>
        <h1 className="page-header__title">{system.name}</h1>
        <p className="page-header__subtitle">Comparing progress with {friendName}</p>
      </div>

      {/* Summary */}
      <div className="compare-summary">
        <div className="compare-summary__col">
          <div className="compare-summary__label">YOU</div>
          <div className="compare-summary__value">{myTotal}/{total}</div>
          <div className="progress-bar">
            <div className="progress-bar__fill" style={{ width: `${myPct}%` }} />
          </div>
          <div className="compare-summary__pct">{myPct}%</div>
        </div>
        <div className="compare-summary__vs">VS</div>
        <div className="compare-summary__col">
          <div className="compare-summary__label">{friendName.toUpperCase()}</div>
          <div className="compare-summary__value">{friendTotal}/{total}</div>
          <div className="progress-bar">
            <div className="progress-bar__fill progress-bar__fill--friend" style={{ width: `${friendPct}%` }} />
          </div>
          <div className="compare-summary__pct">{friendPct}%</div>
        </div>
      </div>

      {/* Trail-by-trail comparison */}
      <div className="compare-trails">
        <div className="compare-trails__header">
          <span className="flex-1">Trail</span>
          <span className="compare-trails__col-label">You</span>
          <span className="compare-trails__col-label">{friendName}</span>
        </div>
        {trails.map(trail => (
          <div key={trail._id} className="compare-trails__row">
            <div className="compare-trails__info">
              <span className="compare-trails__name">{trail.name}</span>
              <div className="compare-trails__meta">
                {trail.length && <span>{trail.length} km</span>}
                <span className={`badge badge--${trail.difficulty}`}>{trail.difficulty}</span>
              </div>
            </div>
            <span className={`compare-trails__check ${trail.myCompleted ? 'compare-trails__check--done' : ''}`}>
              {trail.myCompleted ? '✓' : '—'}
            </span>
            <span className={`compare-trails__check ${trail.friendCompleted ? 'compare-trails__check--done' : ''}`}>
              {trail.friendCompleted ? '✓' : '—'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
